import moment from "moment";
import dayjs from "dayjs";
import "dayjs/locale/vi"; // Import the Vietnamese locale for dayjs
import "moment/locale/vi"; // Import the Vietnamese locale for moment

export const formatDates = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  return moment(date).format("YYYY-MM-DD[T]HH:mm:ss");
};

export function formatDateNotTimeZone(
  date: Date | string | null | undefined
): string {
  if (date === null || date === undefined) {
    return "";
  }
  return moment(date).format("YYYY-MM-DD[T]HH:mm:ss");
}

export const formatDateTransfer = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("DD-MM-YYYY HH:mm:ss");
};

export const formatDateTransferLastYear = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("DD-MM-YY HH:mm:ss");
};

export const formatDateTime = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 1900) return "";
  return moment(date).format("DD-MM-YYYY");
};

export const formatDateTransferOnlyDate = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("DD-MM-YYYY ");
};

export const formatDateTransferOnlyTime = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";
  const date = new Date(dayjs(dateString).add(0, "hour").toDate());
  if (date.getFullYear() < 2000) return "";
  return moment(date).format("HH:mm");
};

export function formatDateToVietnamese(date: Date) {
  const daysOfWeek = [
    "Chủ nhật",
    "Thứ hai",
    "Thứ ba",
    "Thứ tư",
    "Thứ năm",
    "Thứ sáu",
    "Thứ bảy",
  ];
  const dayOfWeek = daysOfWeek[date.getDay()];
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${dayOfWeek}, ngày ${day} tháng ${month} năm ${year}`;
}

export const formatDateTransferVN = (
  dateString: string | Date | undefined | null
): string => {
  if (!dateString) return "";

  // Set dayjs to use Vietnamese locale
  dayjs.locale("vi");

  const date = dayjs(dateString).add(0, "hour").toDate();

  if (date.getFullYear() < 2000) return "";
  const today = dayjs().startOf("day");
  const yesterday = today.subtract(1, "day");

  // Check if the date is today
  if (dayjs(date).isSame(today, "day")) {
    return "Hôm nay";
  }

  // Check if the date is yesterday
  if (dayjs(date).isSame(yesterday, "day")) {
    return "Hôm qua";
  }
  // Set moment to use Vietnamese locale
  moment.locale("vi");

  return moment(date).format("dddd, DD/MM/YYYY");
};
